module.exports = __webpack_public_path__ + "img/Relaisfunkbetrieb.2d7d4fcd.svg";